module.exports = new __parcel__URL__("mining_mission_button_bg.40d54b32.png").toString();